module.exports = __webpack_public_path__ + "img/top-vague3-mobile.716d998f.jpg";